import type { TtuSummary } from "../api";
import { formatTtuPct } from "../format";

const LABELS = { traffic: "Traffic", conversion: "Conversion", units_per_order: "Units per order" } as const;

export function ContributionBar({ contribution, steps }: {
  contribution: TtuSummary["contribution"];
  steps: TtuSummary["steps"];
}) {
  if (contribution.reason === "no_prior_year" || contribution.shares === null) return <p className="text-sm text-muted-foreground">No prior-year data for this view yet.</p>;
  const shares = contribution.shares;
  return <section aria-label="What moved units vs last year" className="grid gap-3">
    <h2 className="text-sm font-semibold text-ks-ink">What moved units vs last year</h2>
    <div className="flex flex-col gap-2 sm:flex-row sm:gap-0 sm:overflow-x-auto sm:rounded-ks-sm">
      {(Object.keys(LABELS) as Array<keyof typeof LABELS>).map((key) => {
        const share = shares[key];
        const mover = contribution.mover === key;
        return <div
          key={key}
          className={mover ? "min-w-40 rounded-ks-sm bg-ks-purple px-3 py-2 text-sm font-semibold text-primary-foreground sm:rounded-none" : "min-w-40 rounded-ks-sm bg-muted px-3 py-2 text-sm text-ks-ink sm:rounded-none"}
          style={{ flexGrow: Math.max(Math.abs(share), 0.15), flexBasis: 0 }}
        >{LABELS[key]} {formatTtuPct(steps[key].yoy_pct ?? null)}</div>;
      })}
    </div>
  </section>;
}
